/* eslint-disable no-return-assign */
import React from 'react';
import { Field as FinalFormField } from 'react-final-form-html5-validation';
import { Flex } from 'rebass';
import styled from 'styled-components';
import colors from 'theme/colors';
import Label from './Label';
import LabelAsterisk from './LabelAsterisk';
import Input from './Input';
import RangeInput from './RangeInput/RangeInput';
import Select from './Select';

const Container = styled(Flex)`
  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;

const FileInputLabel = styled.label<any>`
  width: 150px;
  color: white;
  background: ${colors.primary2};
  font-weight: 600;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;
`;

const StyledFile = styled.input<any>`
  display: none;
`;

interface FieldProps {
  name?: string;
  label?: string;
  fileInputText?: string;
  inputType?: string;
  placeholder?: string;
  validate?: any;
  typeMismatch?: string;
  required?: boolean;
  labelAsterisk?: boolean;
  pattern?: string;
  patternMismatch?: string;
  autoComplete?: string;
  autoFocus?: boolean;
  maxLength?: number | string;
  width?: string;
  height?: string;
  mb?: string;
  rangeDefaultValues?: object;
  rangeMinValue?: number;
  rangeMaxValue?: number;
  numberInputMin?: number;
  numberInputMax?: number;
  selectOptions?: string[];
  changeHandler?: any;
  defaultValue?: string;
  value?: string;
  children?: any;
  afterSubmit?: any;
}

const Field: React.FC<FieldProps> = props => {
  const {
    name,
    label,
    inputType,
    placeholder,
    typeMismatch,
    required,
    labelAsterisk,
    pattern,
    patternMismatch,
    autoComplete,
    rangeDefaultValues,
    rangeMinValue,
    rangeMaxValue,
    selectOptions,
    validate,
    changeHandler,
    fileInputText,
    afterSubmit,
  } = props;
  return (
    <FinalFormField
      name={name}
      type={inputType}
      placeholder={placeholder}
      typeMismatch={typeMismatch}
      required={required}
      pattern={pattern}
      patternMismatch={patternMismatch}
      autoComplete={autoComplete}
      validate={validate}
      afterSubmit={afterSubmit}
    >
      {(fieldProps: any) => {
        const { input } = fieldProps;
        return (
          <Container flexDirection="column">
            <Flex width="100%">
              {label && <Label htmlFor={name}>{label}</Label>}
              {required && labelAsterisk && inputType !== 'checkbox' && <LabelAsterisk />}
            </Flex>
            {(() => {
              switch (inputType) {
                case 'range':
                  return (
                    <RangeInput
                      defaultValues={rangeDefaultValues}
                      minValue={rangeMinValue}
                      maxValue={rangeMaxValue}
                      onChange={input.onChange}
                      {...input}
                    />
                  );
                case 'select':
                  return <Select options={selectOptions} {...input} {...props} />;
                case 'file':
                  return (
                    <FileInputLabel>
                      {fileInputText}
                      <StyledFile
                        {...input}
                        {...props}
                        onChange={(event: any) =>
                          event.target.files && changeHandler(input.name, event.target.files[0])
                        }
                      />
                    </FileInputLabel>
                  );
                default:
                  return <Input {...input} {...props} />;
              }
            })()}
          </Container>
        );
      }}
    </FinalFormField>
  );
};

Field.defaultProps = {
  inputType: 'input',
};

export default Field;
